import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from 'src/app/guards/auth.guard';
import { RolesGuard } from 'src/app/guards/roles.guard';
import { G2ReviewsComponent } from './g2-reviews-home/g2-reviews.component';

const routes: Routes = [
    {
        path: '',
        component: G2ReviewsComponent,
        canActivate: [AuthGuard, RolesGuard],
        data: { roles: ['SuperAdmin'] }
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class G2ReviewsRoutingModule {}
